import {roles} from 'ag-common/tools/roles'

export const buildPermissions = ({role}) => {
  const isAusbilder = role === roles.AUSBILDER
  const isTrainer = role === roles.TRAINER
  const isFachausbilder = role === roles.FACHAUSBILDER
  const isAzubi = role === roles.AZUBI

  const isAzubiOrAusbilderOrFachausbilder = isAzubi || isAusbilder || isFachausbilder
  const isAusbilderOrTrainerOrFachausbilder = isAusbilder || isTrainer || isFachausbilder
  const isAusbilderOrTrainer = isAusbilder || isTrainer
  const isAusbilderOrFachausbilder = isAusbilder || isFachausbilder
  const isAzubiOrAusbilderOrTrainer = isAzubi || isAusbilder || isTrainer

  return {
    searchAzubi: isAusbilderOrTrainerOrFachausbilder,
    abteilungen: {
      view: isAusbilderOrFachausbilder,
    },
    meineAusbilder: {
      manage: isAusbilder,
    },
    meineAbteilungen: {
      manage: isFachausbilder,
    },
    meineAzubis: {
      changeAusbildungsnachweistyp: isAusbilder,
      changeAusbildungsjahr: isAusbilder,
      sendMailToAusbilder: isTrainer,
      hasAzubis: isAusbilderOrTrainerOrFachausbilder,
      canFilterAzubisByMyAbteilungen: isFachausbilder,
      viewUserIds: isAusbilderOrFachausbilder,
    },
    nachweis: {
      edit: isAzubi,
      qualifikation: {
        edit: isAusbilder,
      },
      verify: isAusbilderOrFachausbilder,
      reset: isAusbilder,
      viewNachweiseFromOthers: isAusbilderOrTrainerOrFachausbilder,
      export: {
        single: true,
        multiple: isAzubiOrAusbilderOrTrainer,
      },
    },
    ausbildungsplan: {
      edit: isAzubi,
      viewAusbildungsplanFromOthers: isAusbilderOrTrainerOrFachausbilder,
      verify: isAusbilderOrFachausbilder,
      viewConfirmed: isTrainer,
      comment: {
        edit: isAusbilderOrFachausbilder,
        view: isAzubiOrAusbilderOrFachausbilder,
      },
    },
    versetzungsplan: {
      termine: {
        editAzubiTermin: isAzubi,
        editAusbilderTermin: isAusbilderOrFachausbilder,
      },
      edit: isAusbilderOrFachausbilder,
      editAbteilungseinsaetze: isAusbilder,
    },
    ressourcenplanung: {
      manage: isAusbilder,
    },
    praxisaufgaben: {
      // may edit tasks in educational sense for all azubis
      edit: isAusbilder,
      // may edit tasks in educational sense for azubis in my abteilungen
      editOwnAbteilungen: isFachausbilder,
      check: isAzubi,
      readComment: isAzubiOrAusbilderOrFachausbilder,
      viewPraxisaufgabenFromOthers: isAusbilderOrTrainerOrFachausbilder,
      readOnly: isTrainer,
    },
    wissensportal: {
      viewWissensportalFromOthers: isAusbilderOrTrainerOrFachausbilder,
    },
    allModulesVisible: isAusbilderOrTrainerOrFachausbilder,
    notifications: {
      create: isAusbilderOrTrainer,
    },
    chat: {
      createOrRename: isAusbilderOrTrainerOrFachausbilder,
    },
    feedback: {
      canGetFeedback: isAzubiOrAusbilderOrFachausbilder,
      canUploadFeedbackAnAzubi: isAusbilderOrFachausbilder,
      canUploadFeedbackAsAzubi: isAzubi,
    },
    filter: {
      hasAbteilungsFilter: isAusbilderOrFachausbilder,
    },
  }
}
